export default __webpack_public_path__ + "media/components/Courses/Show/Images/prospects-9888d2a82cb0da5591754c519a8a90fa.svg";